export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Provincia',
	plural_model_name_spanish: 'Provincias',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}